import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { createStripeCheckout } from '../utils/api';
import {
    Button,
    CircularProgress,
    Box
} from '@mui/material';

// Initialize Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const PaymentButton = ({
    onSuccess,
    onError,
    amount = 1000,
    description = "Find solution - Dostęp do PDF",
    buttonText = "Zapłać",
    email = ""
}) => {
    const [loading, setLoading] = useState(false);

    const handlePayment = async () => {
        setLoading(true);

        try {
            const stripe = await stripePromise;

            if (!stripe) {
                throw new Error('Stripe nie został załadowany');
            }

            // Create checkout session
            const session = await createStripeCheckout(amount, description, email);

            // Redirect to Stripe Checkout
            const result = await stripe.redirectToCheckout({
                sessionId: session.id
            });

            if (result.error) {
                throw new Error(result.error.message);
            }

        } catch (err) {
            console.error('Payment error:', err);
            if (onError) onError(err);
        } finally {
            setLoading(false);
        }
    };

    // Simple payment simulation for development
    const handlePaymentSimulation = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            if (onSuccess) onSuccess();
        }, 2000);
    };

    // Use simulation if no Stripe keys are configured
    const useSimulation = !process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
        process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY.includes('...');

    return (
        <Button
            variant="outlined"
            onClick={useSimulation ? handlePaymentSimulation : handlePayment}
            disabled={loading}
            sx={{
                minWidth: 140,
                py: 1.5,
                borderRadius: 2,
                borderColor: 'primary.main',
                background: 'transparent',
                color: 'primary.main',
                '&:hover': {
                    background: 'transparent',
                    borderColor: 'secondary.main',
                    transform: 'scale(1.05)'
                },
                '&:disabled': {
                    background: 'grey.400',
                    transform: 'none'
                }
            }}
        >
            {loading ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={16} color="inherit" />
                    Płacę...
                </Box>
            ) : (
                buttonText
            )}
        </Button>
    );
};

export default PaymentButton;
